import Vue from 'vue';
import router from '../../router';
import store from '../../store';
import { i18n } from '../../localization';
import { errorHandler } from './helpers';
import { ERROR } from '../../constants';

/**
 * Common delete handler
 * @param {Function} resourceName
 * @param {Number} id
 * @param {Function} loadList
 * @param {String} routeName
 * @param {Object} confirmPart
 */
export const deleteHandler = (
    resourceName,
    id,
    loadList,
    routeName,
    confirmPart = {
        confirmTitle: i18n.t('common.confirmDialog'),
        confirmBody: i18n.t('common.confirm'),
    }
) => {
    let { confirmTitle, confirmBody } = confirmPart;
    let confirmMessage = {
        confirmTitle,
        confirmBody,
        confirmOk: i18n.t('common.ok'),
        confirmCancel: i18n.t('common.cancel'),
    };

    return store.dispatch('confirm/confirmation', confirmMessage).then(r => {
        if (r) {
            store.commit('SHOW_LOADING', true);
            return resourceName({ method: 'delete', id })
                .then(() => {
                    return loadList().then(() => {
                        store.commit('SET_UNSAVED_CHANGES', false);
                        Vue.nextTick(() => {
                            router.replace({
                                name: routeName,
                            });
                        });
                        store.commit('SHOW_LOADING', false);
                    });
                })
                .catch(response => {
                    if (response.data && response.data.error) {
                        if (!response.request.status === 404) {
                            store
                                .dispatch('popup/popup', {
                                    text: i18n.t(response.data.error),
                                    type: ERROR,
                                    header: i18n.t('common.error'),
                                })
                                .catch(() => {});
                        }
                    }
                    return loadList()
                        .then(() => {
                            store.commit('SET_UNSAVED_CHANGES', false);
                            Vue.nextTick(() => {
                                errorHandler(response.status, routeName);
                            });
                            store.commit('SHOW_LOADING', false);
                        })
                        .catch(() => store.commit('SHOW_LOADING', false));
                });
        }
    });
};
